import Vue from 'vue'

// @see more https://www.npmjs.com/package/vue-inputmask
const VueInputMask = require('vue-inputmask').default
Vue.use(VueInputMask)

import App from './App.vue'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#project-estimation')
